import React, { ChangeEvent, ReactNode } from 'react';

import './styles.scss';

interface Props {
    id: string;
    value: string;
    checked: boolean;
    children: ReactNode;
    className?: string;
    onChange: (id: string, value: string) => void;
}

export const RadioSelectWithContent = ({ id, value, checked, children, className = '', onChange }: Props) => {
    const changeHandler = (e: ChangeEvent<HTMLInputElement>) => onChange(id, e.target.value);

    return (
        <div className={`radio-select-with-content ${className}`}>
            <input
                type='radio'
                id={value}
                value={value}
                checked={checked}
                onChange={changeHandler}
                className='radio-select-with-content__input'
            />
            <label className='radio-select-with-content__label' htmlFor={value}>
                <span className='radio-select-with-content__radio-icon'></span>
                {children}
            </label>
        </div>
    );
};
